import React from "react";
import { Spinner } from "@blueprintjs/core";

export default function LoadingIndicator({ size = 50 }) {
  return (
    <div>
      <Spinner intent="primary" size={size} className="loading-indicator" />
    </div>
  );
}
